import styled from "@emotion/styled"

export const ToggleButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: 10px;
    cursor: pointer;
`

export const ToggleButton = styled.span`
    text-align: center;
    font-size: 10px;
`